import styled, { css } from 'styled-components';
import { iconBan, regularWhite } from '../../../design-tokens';
import PlayImage from '../../../PlayImage/PlayImage';
import { playFontSize } from '../../../typography/helpers';

export const StyledContentItemFigure = styled(PlayImage)`
    ${(props) =>
        props.onlyAvailableInSweden &&
        !props.editModeActivated &&
        css`
            .no-sweden & :after {
                font-family: svt-icons;
                content: '${iconBan}';
                position: absolute;
                margin-top: -0.5em;
                margin-left: -0.5em;
                top: 50%;
                left: 50%;
                z-index: 10;
                text-align: center;
                color: ${regularWhite};
                color: rgba(255, 255, 255, 0.65);
                ${playFontSize(4.5)}
            }
        `}
`;

export const Overlay = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100.5%;
    z-index: 10;
    text-align: center;
    color: ${regularWhite};
    color: rgba(255, 255, 255, 0.65);
`;

export const OutsideSwedenOverlay = styled(Overlay)`
    display: none;

    .no-sweden & {
        display: block;
    }
`;
